








import Vue from 'vue';
import { VMoney } from 'v-money';

// Using :key to force rerender does not work with this component. For some reason, v-money is
// not included in the component lifecycle when key is changed.
//
// also, as v-model.lazy listens to change events, we need to use the nextTick() from force
// rerendering to change the current value; if we do it in the same tick, the process loops forever.
export default Vue.extend({
  props: [
    'name',
    'initialValue',
    'required',
  ],
  data: () => ({
    currentValue: '',
    money: {
      decimal: '.',
      thousands: ',',
      prefix: 'AUD ',
      precision: 2,
      masked: false,
    },
    renderComponent: true,
  }),
  created() {
    this.synchroniseFromParent();
  },
  directives: {
    money: VMoney,
  },
  watch: {
    currentValue(val, old) {
      if ((typeof val === 'string') && (val !== old)) {
        const value = val.replace(/\D/g, '');
        this.$emit('valueChange', parseInt(value, 10));
      }
    },
    initialValue(val, old) {
      if ((typeof val === 'undefined') || ((typeof val === 'number') && (val !== old))) {
        this.renderComponent = false;

        this.$nextTick().then(() => {
          this.renderComponent = true;
          if (typeof val === 'undefined') {
            this.currentValue = '';
          } else {
            this.currentValue = val.toString();
            this.$nextTick().then(() => {
              this.focusNow();
            });
          }
        });
      }
    },
  },
  methods: {
    focusNow(): void {
      ((this.$refs.moneyInput as Vue).$el as HTMLElement).focus();
    },
    synchroniseFromParent() {
      this.currentValue = this.initialValue;
    },
  },
});
